import React from 'react';

import {
    removeAttributeById,
    removeAttributeByIdFailure,
    removeAttributeByIdSuccess,
} from 'src/openapi/apis/AttributeControllerApi';
import {getEventById} from 'src/openapi/apis/EventControllerApi';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {OnCloseNote, Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    id: number,
    name: string,
    eventId: number,
    onClose: OnCloseNote,
};

export const PushNotificationRemoveAttribute = ({id, name, eventId, onClose}: Props) => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();

    const onClick = () => {
        dispatch(removeAttributeById({id})).then(e => {
            if (e.type === removeAttributeByIdSuccess.type) {
                onClose(`${id}`).then(() => {
                    dispatch(getEventById({id: eventId}));
                });
            }

            if (e.payload.error && e.type === removeAttributeByIdFailure.type) {
                onCreateNote({
                    id: removeAttributeByIdFailure.type,
                    status: Status.ERROR,
                    message: e.payload.data.message,
                    buttonProps: {icon: Icons.CLOSE},
                    autoHideTimeout: 10000,
                });
            }
        });
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group gap="none" style={{maxWidth: '90%'}}>
                <Group gap="xs" style={{minWidth: '70%'}}>
                    <Item shrink={0}>Delete attribute</Item>
                    <EllipsisTextHint bold={true}>{name}</EllipsisTextHint>
                </Group>
                <Item>?</Item>
            </Group>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
